import axios from "axios";
import { UNATHORIZED_CODE, INVALID_AUTH_FIELDS } from "@/const";

const HTTP = axios.create({
  baseURL:
    process.env.VUE_APP_API_GATEWAY ||
    "https://st-api-gateway.metime.com/api/v1/",
  headers: { accept: "application/json", "Content-Type": "application/json" },
});

HTTP.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === UNATHORIZED_CODE) {
      return Promise.reject(INVALID_AUTH_FIELDS);
    }
    return Promise.reject(error.response?.data);
  },
);

export const login = function (login, password) {
  return HTTP.post(
    "authentication",
    { login, password },
    { withCredentials: true },
  );
};

export const signUp = function (
  {
    email,
    password,
    firstName,
    lastName,
    clinicName,
    websiteLink,
    userRole = "ADMIN",
  },
  transfer_uuid,
) {
  let config;
  if (transfer_uuid) {
    config = { params: { transfer_uuid } };
  }
  return HTTP.post(
    "users/register",
    {
      email,
      password,
      firstName,
      lastName,
      clinicName,
      websiteLink,
      userRole,
    },
    config,
  );
};

export const forgotPasswordSendEmail = (email) =>
  HTTP.get(`users/password/reset/${email}`);
export const checkPasswordToken = (token) =>
  HTTP.get(`users/password/check-token/${token}`);
export const saveNewPassword = (token, newPassword) =>
  HTTP.post("users/password/save/", {
    token,
    newPassword,
  });
export const getTokenByGoogle = (googleToken) =>
  HTTP.get(`login/google/${googleToken}`);
export const getTokenByFacebook = (facebookToken) =>
  HTTP.get(`login/facebook/${facebookToken}`);
